/**
 * GlobalWindowManager — rendert alle über WindowManagerContext geöffneten
 * Fenster EINMAL im App-Layout (siehe Layout.js), analog zu
 * GlobalEmailComposer. Dadurch bleibt der Zustand eines Fensters beim
 * Wechseln zwischen Tabs/Routen erhalten, statt beim Verlassen der
 * aufrufenden Seite verloren zu gehen.
 */
import ManagedWindow from './ManagedWindow';
import { useWindowManager } from '../../contexts/WindowManagerContext';

export default function GlobalWindowManager() {
  const { windows, closeWindow } = useWindowManager();

  return (
    <>
      {windows.map((win) => (
        <ManagedWindow key={win.id} win={win} onClose={() => closeWindow(win.id)} />
      ))}
    </>
  );
}
